export enum Language {
    En,
    De,
    Es,
    Fr,
    It,
    Pt,
    Cn,
    Tr,
    Nl,
    Pl,
    Cs
}
